import { axiosInstance } from './axiosInstance';

export const GET_CUSTOMERS_SERVICE = (param) => {
  const url = `/api/cs/list?type=${param}`;
  const res = axiosInstance.get(url);
  return res;
};
